<template>
    <b-form>
        <!-- Una sola fila: Empresa, Búsqueda y Botones -->
        <b-row class="mb-3 align-items-end">
            <!-- Empresa -->
            <b-col cols="12" sm="6" md="4" lg="4" class="mb-2 mb-md-0">
                <label for="empresa" class="d-none d-md-block">
                    <i class="fa fa-building"></i> Empresa
                </label>
                <el-select id="empresa" name="empresa" filterable clearable v-model="localCompanyId"
                    placeholder="Seleccione una empresa" size="medium" remote :remote-method="searchCompany"
                    :disabled="loading" :loading="loading" style="width: 100%">
                    <el-option v-for="empresa in empresas" :key="empresa.id" :label="empresa.nombre"
                        :value="empresa.id" />
                </el-select>
            </b-col>

            <!-- Búsqueda -->
            <b-col cols="12" sm="6" md="4" lg="4" class="mb-2 mb-md-0">
                <label class="d-none d-md-block">&nbsp;</label>
                <b-form-input v-model="filter.search" placeholder="Buscar diagnósticos..."
                    :disabled="!localCompanyId || loading"></b-form-input>
            </b-col>

            <!-- Botones -->
            <b-col cols="12" sm="12" md="4" lg="4" class="text-md-right mb-2 mb-md-0">
                <label class="d-none d-md-block">&nbsp;</label>
                <div class="d-flex justify-content-md-end">
                    <b-button variant="outline-primary" @click="$emit('toggle-filters')" :disabled="!localCompanyId"
                        class="mr-2 flex-grow-1 flex-md-grow-0" size="md">
                        <i class="fa fa-filter"></i> Filtros
                    </b-button>
                    <b-button variant="outline-danger" @click="handleClearFilters" :disabled="!localCompanyId"
                        class="flex-grow-1 flex-md-grow-0" size="md">
                        <i class="fa fa-times"></i> Limpiar
                    </b-button>
                </div>
            </b-col>
        </b-row>

        <!-- Filtros Colapsables -->
        <div v-if="localCompanyId && showFilters">
            <hr class="my-3" />

            <b-row class="mb-3">
                <!-- Ubicación -->
                <b-col cols="12" md="4" class="form-group">
                    <label for="id_ubicacion">Ubicación</label>
                    <tree-select v-model="filter.location_id" id="ubicacion" name="ubicacion" :multiple="false"
                        :defaultExpandLevel="Infinity" :options="treeWithChildrens" :disabled="!companyId || loading"
                        placeholder="Todas las ubicaciones" />
                </b-col>

                <!-- Lista de Chequeo -->
                <b-col cols="12" md="4" class="form-group">
                    <label for="check_list">Lista de Chequeo</label>
                    <el-select id="check_list" name="check_list" filterable clearable
                        v-model="filter.check_lists_companies_id" placeholder="Todas las listas" size="medium"
                        :disabled="!companyId || loading" :loading="loading">
                        <el-option v-for="item in safeCheckListCompany" :key="item.id"
                            :label="item.check_list ? item.check_list.name : 'Sin nombre'" :value="item.id" />
                    </el-select>
                </b-col>

                <!-- Champion / Responsable principal -->
                <b-col cols="12" md="4" class="form-group">
                    <label for="Champion / Responsable principal">Champion / Responsable principal</label>
                    <el-select id="Champion / Responsable principal" name="Champion / Responsable principal" filterable
                        clearable v-model="filter.responsible_id"
                        placeholder="Todos los Champion / Responsable principals" size="medium"
                        :disabled="!companyId || loading" :loading="loading">
                        <el-option v-for="worker in safeWorkers" :key="worker.id" :label="worker.fullName"
                            :value="worker.id" />
                    </el-select>
                </b-col>
            </b-row>

            <b-row class="mb-2">
                <!-- Fecha Diagnóstico (Rango) -->
                <b-col cols="12" md="4" class="form-group">
                    <label for="diagnostic_date_range">Fecha Diagnóstico</label>
                    <el-date-picker v-model="diagnosticDateRange" type="daterange" range-separator="a"
                        start-placeholder="Fecha inicio" end-placeholder="Fecha fin" format="dd/MM/yyyy"
                        value-format="yyyy-MM-dd" size="medium" :disabled="!companyId || loading" style="width: 100%">
                    </el-date-picker>
                </b-col>

                <!-- Fecha Seguimiento (Rango) -->
                <b-col cols="12" md="4" class="form-group">
                    <label for="follow_up_date_range">Fecha Seguimiento</label>
                    <el-date-picker v-model="followUpDateRange" type="daterange" range-separator="a"
                        start-placeholder="Fecha inicio" end-placeholder="Fecha fin" format="dd/MM/yyyy"
                        value-format="yyyy-MM-dd" size="medium" :disabled="!companyId || loading" style="width: 100%">
                    </el-date-picker>
                </b-col>

                <!-- Estado -->
                <b-col cols="12" md="4" class="form-group">
                    <label for="estado">Estado</label>
                    <el-select id="estado" name="estado" clearable v-model="filter.is_active" placeholder="Todos"
                        size="medium" :disabled="!companyId || loading">
                        <el-option label="Activo" :value="1" />
                        <el-option label="Inactivo" :value="0" />
                    </el-select>
                </b-col>
            </b-row>
        </div>
    </b-form>
</template>

<script>
import TreeSelect from "@riophae/vue-treeselect";
import { mapActions, mapState } from "vuex";

export default {
    name: "FiltersDiagnostics",
    components: { TreeSelect },
    data() {
        return {
            localCompanyId: null,
            filter: {
                search: "",
                location_id: null,
                check_lists_companies_id: null,
                responsible_id: null,
                diagnostic_date: null,
                follow_up_date: null,
                is_active: null,
            },
            diagnosticDateRange: null,
            followUpDateRange: null,
        };
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        showFilters: {
            type: Boolean,
            default: false,
        },
        selectedCompanyId: {
            type: [Number, String],
            default: null,
        },
    },
    methods: {
        ...mapActions("location", ["getTreeWithChildrens"]),
        ...mapActions("skudo/checklist", ["getCheckListCompany"]),
        ...mapActions("trainings", ["fetchWorkers"]),
        ...mapActions("tareas", ["obtenerEmpresas"]),

        async searchCompany(val) {
            await this.obtenerEmpresas(val);
        },

        async loadFiltersData() {
            if (!this.localCompanyId) return;

            try {
                // Cargar ubicaciones, checklists y workers
                await Promise.all([
                    this.getTreeWithChildrens({ company_id: this.localCompanyId }),
                    this.getCheckListCompany(this.localCompanyId),
                    this.fetchWorkers(this.localCompanyId),
                ]);
            } catch (error) {
            }
        },

        emitFilters() {
            const filters = { ...this.filter };

            if (this.diagnosticDateRange && this.diagnosticDateRange.length === 2) {
                filters.diagnostic_date = this.diagnosticDateRange;
            }

            if (this.followUpDateRange && this.followUpDateRange.length === 2) {
                filters.follow_up_date = this.followUpDateRange;
            }

            this.$emit("filters-changed", filters);
        },

        handleClearFilters() {
            this.filter = {
                search: "",
                location_id: null,
                check_lists_companies_id: null,
                responsible_id: null,
                diagnostic_date: null,
                follow_up_date: null,
                is_active: null,
            };
            this.diagnosticDateRange = null;
            this.followUpDateRange = null;
            this.$emit("clear-filters");
        },
    },
    computed: {
        ...mapState("location", ["treeWithChildrens"]),
        ...mapState("skudo/checklist", ["checkListCompany"]),
        ...mapState("trainings", ["workers"]),
        ...mapState("tareas", ["empresas"]),

        companyId() {
            return this.localCompanyId;
        },

        // Validar que los datos existan antes de usarlos
        safeCheckListCompany() {
            return Array.isArray(this.checkListCompany) ? this.checkListCompany : [];
        },

        // Formatear workers igual que en ViewWorkers.vue
        safeWorkers() {
            if (!this.workers || !this.workers.length) return [];
            return this.workers.map((worker) => ({
                ...worker,
                fullName: `${worker.names || ''} ${worker.surnames || ''}`.trim(),
            }));
        },
    },
    watch: {
        // Sincronizar prop con data local
        selectedCompanyId: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal !== this.localCompanyId) {
                    this.localCompanyId = newVal;
                }
            }
        },
        // Watcher del data local
        localCompanyId: {
            async handler(newVal) {
                if (newVal) {
                    await this.loadFiltersData();
                    this.$emit("company-changed", newVal);
                } else {
                    // Limpiar filtros cuando no hay empresa
                    this.filter = {
                        search: "",
                        location_id: null,
                        check_lists_companies_id: null,
                        responsible_id: null,
                        diagnostic_date: null,
                        follow_up_date: null,
                        is_active: null,
                    };
                    this.diagnosticDateRange = null;
                    this.followUpDateRange = null;
                    // Emitir evento para limpiar datos en el padre
                    this.$emit("company-changed", null);
                }
            },
        },
        filter: {
            handler() {
                this.emitFilters();
            },
            deep: true,
        },
        diagnosticDateRange() {
            this.emitFilters();
        },
        followUpDateRange() {
            this.emitFilters();
        },
    },
};
</script>

<style scoped>
::v-deep .vue-treeselect__no-children-tip {
    display: none !important;
}

::v-deep .vue-treeselect__no-children-tip .vue-treeselect__icon {
    display: none !important;
}

.vue-treeselect__control {
    min-height: 30px !important;
    font-size: 14px !important;
}

.imagen-checkbox {
    box-shadow: 0 0 3px #b8b8b8;
}

.is-checked .imagen-checkbox {
    box-shadow: 0px 1px 10px #097b83;
    border: 1px solid #097b83;
}

.checkbox-imagen .el-radio__input {
    display: none;
}
</style>